module.exports = __webpack_public_path__ + "img/util-water.90bd043e.svg";